export default __webpack_public_path__ + "static/media/welcome-icon-play.81889ff0.png";